angular.module('common.directives').directive('ngTableLoading', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      scope: true,
      link: (scope, element, attrs) => {
        const template = `<div class="ng-table-loading" layout="row" layout-sm="column" layout-align="center center" ng-if="loading">
					<md-progress-circular md-mode="indeterminate"></md-progress-circular>
				</div>`
        element.append($compile(template)(scope))
        scope.$watch(attrs.ngTableLoading, value => {
          scope.loading = value
        })
      }
    }
  }
])
